export default __webpack_public_path__ + "static/media/whatsapp_offer.aef5af5f.png";